import FpLoginSelector from 'forepaas/client-authority-manager/FpLoginSelector.jsx'

class LoginSelector extends FpLoginSelector {
}

export default LoginSelector
